import {
  Component,
  HostListener
} from "@angular/core";
import { PrimeNGConfig, Translation } from "primeng/api";
import { AddToHomeScreenService } from "./_app_modules/mojo-for-tenants/add-to-homescreen-service/add-to-homescreen.service";

@Component({
  selector: "mojo-app",
  templateUrl: "./app.component.html",
})
export class AppComponent {

  constructor(
    private readonly addToHomeScreenService: AddToHomeScreenService,
    private readonly config: PrimeNGConfig) {
    this.config.setTranslation({
      dateFormat: 'dd/mm/yy'
      //translations
    } as Translation);
  }

  //Listens to beforeInstallPrompt event being triggered
  @HostListener("window:beforeinstallprompt", ["$event"])
  onbeforeinstallprompt(e: any) {
    //Passes event to addToHomeScreenService
    this.addToHomeScreenService.addToHomeScreen(e);
  }
}
